import React from "react";
import { useLocation } from "react-router-dom";
import LANDINGSECTION from "../../constants/LandingConstant";
import GovernDropdownContent from "./GovernDropdownContent";

const DropdownContent = (props) => {
  const location = useLocation();
  const landingsectioncondition =
    location?.pathname === LANDINGSECTION.DATABOOK_LANDING_URL;
  return (
    <div className="dropdown__section">
      {landingsectioncondition ? (
        <GovernDropdownContent dropdownData={props.dropdownData} />
      ) : (
        <>
          <GovernDropdownContent dropdownData={props.dropdownData} />
        </>
      )}
    </div>
  );
};

export default DropdownContent;
